import { connect } from 'react-redux'

import Component from './Component'

import componentDidMount from './Handlers/componentDidMount'
import onChangeSearch from './Handlers/onChangeSearch'
import onSubmitSearch from './Handlers/onSubmitSearch'
import onChangeFilter from './Handlers/onChangeFilter'
import onChangeTable from './Handlers/onChangeTable'
import onClickRow from './Handlers/onClickRow'

const mapStateToProps = (state) => ({
  tbtSignings: state.screens.TBTSigning.tbtSignings,
  fetching: state.screens.TBTSigning.fetching,
  searchTerm: state.screens.TBTSigning.searchTerm,
  filters: state.screens.TBTSigning.filters,
  pagination: state.screens.TBTSigning.pagination,
})

const actionCreators = {
  componentDidMount,
  onChangeTable,
  onChangeSearch,
  onSubmitSearch,
  onClickRow,
  onChangeFilter,
}

export default connect(mapStateToProps, actionCreators)(Component)
